/* eslint-disable no-console */
/* eslint-disable react/style-prop-object */
/* eslint-disable max-len */
import React, { FC, useEffect, useRef, useState } from "react";
import Typography from "@mui/material/Typography";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardMedia,
  Container,
  Grid,
  IconButton,
  List,
  ListItem,
  Menu,
  MenuItem,
  Modal,
  Popover,
  Popper,
  Snackbar,
} from "@mui/material";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import InfiniteScroll from "react-infinite-scroll-component";
import CaladreTheme from "theme/Theme";
import discussionService from "services/discussionService";
import { setPriority } from "os";
import NotificationService, { ChatMessage } from "services/notificationService";
import MessageArea from "../shared/messageArea/MessageArea";
import classes from "../style";
import userService from "services/userService";
import { AsyncCardMedia } from "components/AsyncCardMedia";
import { AsyncAvatar } from "components/AsyncAvatar";
import PublicUser from "models/PublicUser";
import { getImageUrl } from "utils/imageUtils";
import reportService from "services/reportService";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { UserMinimal } from "components/UserMinimal";
import { useSelector } from "react-redux";
import { RootState } from "store";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import AdSlot from "components/AdSlot";

const Messagerie: FC<{}> = () => {
  const [selectedDestination, setSelectedDestination] =
    React.useState<any>(null);
  const currentUserId = useSelector<RootState>(s => s.globalSlice.user?.id);
  const [selectedContact, setSelectedContact] = React.useState<any>(null);
  const [openMembresList, setOpenMembresList] = React.useState<boolean>(false);
  const [guest, setGuest] = React.useState<PublicUser>();
  const [guests, setGuests] = React.useState<PublicUser[]>([]);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [init, setInit] = useState(false);

  const [openSignalerMsg, setOpenSignalerMsg] = React.useState(false);
  const [anchorElSignalerMsg, setAnchorElSignalerMsg] =
    React.useState<null | HTMLElement>(null);

  const [discussions, setDiscussions] = useState<any[]>([]);
  const [destinations, setDestinations] = useState<any[]>([]);
  const [messages, setMessagesState] = useState<any[]>([]);
  const [messagePage, setMessagePage] = useState<number>(0);
  const [hasNext, setHasNext] = useState<boolean>(true);
  const [startDate, setStartDate] = useState<Date>(new Date());

  const [popoverUser, setPopoverUser] = useState<string | undefined>(undefined);
  const [anchorPop, setAnchorPop] = React.useState<HTMLElement | null>(null);

  const [snack, setSnack] = useState<string | undefined>(undefined);

  const contactRef = useRef(selectedContact);
  const messagesRef = useRef(messages);

  const open = Boolean(anchorEl);

  const setMessages = (m: any[]) => {
    setMessagesState(m);
    messagesRef.current = m;
  }

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const report = async (userId: string) => {
    await reportService.report(userId);
    setSnack("L'utilisateur a été signalé. Vous recevrez prochainement un email.");
  }

  const loadMessages = async () => {
    const page = messagePage + 1;
    const d = await discussionService.getFullDiscussion(
      selectedContact.discussionId,
      page,
      startDate
    );
    setMessagePage(page);
    setMessages([...messages, ...d]);

    if (d.length < 20) {
      setHasNext(false);
    }
  };

  const onChatMessageReceived = (message: any) => {
    const contact = contactRef.current;
    if (contact != null && contact.discussionId === message.discussionId && messages.every(m => m.id != message.id)) {
      setMessages([...messagesRef.current, message]);
    }
  };

  const submitMessage = async (message: string | null) => {
    if (message == null || selectedContact == null) return;

    if (!await discussionService.sendMessage(message, selectedContact.discussionId)) {
      setSnack("Vous devez attendre de recevoir un message pour pouvoir en envoyer un nouveau.");
    }
  };

  if (!init) {
    if (NotificationService().connected) {
      NotificationService().onChatMessages(onChatMessageReceived);
    }
    setInit(true);
  }

  useEffect(() => {
    setSelectedContact(null);
  }, [selectedDestination]);

  useEffect(() => {
    setStartDate(new Date());
  }, [selectedContact])

  useEffect(() => {
    const loadDiscussion = async () => {
      const d = await discussionService.getFullDiscussion(
        selectedContact.discussionId,
        0,
        new Date()
      );
      setMessagePage(0);
      setMessages(d);
    };

    const loadGuests = async () => {
      setGuests(await discussionService.getGuests(selectedContact.discussionId));
    };

    if (selectedContact) {
      // setGuests(
      //   selectedDestination?.contacts?.filter(
      //     (e) => e.nomComplet !== selectedContact.nomComplet,
      //   ),
      // );

      setHasNext(true);

      loadDiscussion();
      loadGuests();
    }
  }, [selectedContact]);

  const displayDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };

  useEffect(() => {
    const getDiscussions = async () => {
      const userDiscussions = await discussionService.getUserDiscussions();
      setDiscussions(userDiscussions);
      setDestinations(
        userDiscussions
          .map((d) => d.destination)
          .filter(
            (v, i, a) =>
              a.indexOf(a.find((t) => t.destinationId === v.destinationId)) ===
              i,
          ),
      );
    };

    if (discussions.length === 0) {
      getDiscussions();
    }
  }, []);

  const inviteGuest = async (contact: PublicUser) => {
    await discussionService.invite(selectedContact.discussionId, contact.id);
  }

  return (
    <Container
      disableGutters
      sx={{
        ...classes.root,
        ...classes.calendrier,
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
      }}
    >

      <AdSlot zone='MESSAGES_TOP' />

      <Typography variant="h1" my={5}>
        MESSAGERIE
      </Typography>

      <Box
        sx={{
          width: "100%",
          position: "relative",
        }}
      >
        <Grid container sx={classes.messagerie} my={3}>
          <Grid
            item
            xs={12}
            md={3}
            sx={{
              display: {
                xs: selectedDestination ? "none" : "block",
                md: "block",
              },
            }}
          >
            <Typography component="div" variant="h5" color="primary">
              Destinations
            </Typography>
            <List>
              {destinations.map((destination: any) => (
                <ListItem onClick={() => setSelectedDestination(destination)}>
                  <Typography
                    component="div"
                    variant="h6"
                    color={
                      destination.destinationName ===
                        selectedDestination?.destinationName
                        ? "primary"
                        : "default"
                    }
                  >
                    {destination.destinationName}
                  </Typography>
                </ListItem>
              ))}
            </List>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
            sx={{
              display: {
                xs: selectedDestination && !selectedContact ? "block" : "none",
                md: "block",
              },
              borderLeft: {
                xs: "none",
                md: "1px solid #707070",
              },
            }}
          >
            <Typography
              component="div"
              variant="h5"
              color="primary"
              display="flex"
              alignItems="center"
            >
              <ArrowBackIosIcon
                sx={{
                  display: {
                    xs: "block",
                    md: "none",
                  },
                }}
                onClick={() => setSelectedDestination(null)}
              />
              Contacts
            </Typography>
            {selectedDestination != null ? (
              discussions
                .filter(
                  (d) =>
                    d.destination.destinationId ===
                    selectedDestination.destinationId,
                )
                .filter((d) => d.lastMessageUser != null)
                .map((discussion: any) => (
                  <Card
                    onClick={() => {
                      setSelectedContact(discussion);
                      contactRef.current = discussion;
                    }}
                    sx={{
                      backgroundColor:
                        selectedContact?.discussionId ===
                          discussion.discussionId
                          ? "#E8E7E7"
                          : "#FFF",
                    }}
                  >
                    <AsyncCardMedia
                      props={{ component: "img", width: "30", alt: discussion.lastMessageUser.name, height: 30 }}
                      url={userService.getProfilPicture(discussion.lastMessageUser.userId)}
                    />
                    <Box display="flex" flexDirection="column" sx={{ width: '100%' }}>
                      <Typography component="div" variant="h5">
                        {discussion.lastMessageUser.name}
                      </Typography>
                      <Typography component="div" variant="body2" sx={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>
                        {discussion.lastMessage}
                      </Typography>
                      <Typography component="div" variant="body2">
                        {displayDate(new Date(discussion.lastMessageDate))}
                      </Typography>
                    </Box>
                  </Card>
                ))
            ) : (
              <Typography sx={{ my: 1 }}>
                Sélectionner les destinations
              </Typography>
            )}
          </Grid>
          <Grid
            item
            xs={12}
            md={5}
            sx={{
              display: {
                xs: selectedDestination && selectedContact ? "block" : "none",
                md: "block",
              },
              borderLeft: {
                xs: "none",
                md: "1px solid #707070",
              },
            }}
          >
            <Typography
              component="div"
              variant="h5"
              color="primary"
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <Box display="flex" alignItems="center">
                <ArrowBackIosIcon
                  sx={{
                    display: {
                      xs: "block",
                      md: "none",
                    },
                  }}
                  onClick={() => setSelectedContact(null)}
                />
                Messagerie
              </Box>
              <MoreHorizIcon onClick={(e: any) => handleClick(e)} />
            </Typography>
            {messages.length > 0 && (
              <Box
                sx={{
                  ...classes.chat,
                  maxHeight: "400px",
                  overflowY: "scroll",
                }}
              >
                <InfiniteScroll
                  dataLength={Math.max(0, messages.length - 1)}
                  next={loadMessages}
                  loader={<div />}
                  hasMore
                >
                  {messages.map((m) => (
                    <Card>
                      <Box onClick={async (e) => {
                        const target = e.currentTarget!;
                        if (m.userId !== currentUserId && await userService.canViewPublic(m.userId)) {
                          setPopoverUser(m.userId);
                          setAnchorPop(target);
                        }
                      }}>
                        <AsyncAvatar props={{ alt: m.firstName }} url={userService.getProfilPicture(m.userId)} />
                      </Box>
                      <Box display="flex" flexDirection="column">
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent="space-between"
                          sx={{ p: "0 !important" }}
                        >
                          <Typography component="div" variant="h5">
                            {m.firstName}
                            <span>{displayDate(new Date(m.creationDate))}</span>
                          </Typography>
                          <IconButton
                            onClick={() => report(m.id)} sx={{ ml: 2 }}>
                            <Typography sx={{ fontSize: '8px !important' }}>Signaler</Typography>
                          </IconButton>
                          {/* <IconButton
                            color="primary"
                            aria-label="upload picture"
                            aria-describedby="0"
                            component="label"
                          >
                            <MoreHorizIcon
                              color="info"
                              onClick={(event: any) => {
                                setAnchorElSignalerMsg(event.currentTarget);
                                setOpenSignalerMsg(
                                  (previousOpen) => !previousOpen,
                                );
                              }}
                            />
                          </IconButton>
                          <Popper
                            id="0"
                            open={openSignalerMsg}
                            anchorEl={anchorElSignalerMsg}
                            placement="left"
                          >
                            <Box sx={{ px: 1 }}>
                              <Typography sx={classes.reportMsg}>
                                Signaler le message
                              </Typography>
                            </Box>
                          </Popper> */}
                        </Box>
                        <Typography component="div" variant="body2" style={{ wordBreak: 'break-all', wordWrap: 'break-word' }}>
                          {m.message}
                        </Typography>
                      </Box>
                    </Card>
                  ))}
                </InfiniteScroll>
                {/* {guest && (
                  <Typography
                    sx={{
                      color: CaladreTheme.palette.info.main,
                      textAlign: "center",
                      fontSize: "10px",
                    }}
                  >
                    {guest.nomComplet} a rejoint la conversation
                  </Typography>
                )} */}
              </Box>
            )}
            <Box display="flex" alignItems="center">
              <MessageArea
                withSubmitButton={false} clearOnSubmit
                handleSubmit={(e: any) => submitMessage(e)}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>

      <AdSlot zone='MESSAGES_BOT' />

      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
            "& li": {
              fontSize: "10px",
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem onClick={() => setOpenMembresList(true)}>
          Ajouter un membre au groupe
        </MenuItem>
      </Menu>
      <Modal
        open={openMembresList}
        onClose={() => setOpenMembresList(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute" as "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            borderColor: "transparent",
            borderRadius: "4px",
            boxShadow: 24,
            p: 4,
            "&:focus, &:active": {
              borderColor: "transparent",
              outline: 0,
            },
          }}
        >
          {guests && guests.length > 0 ? (
            guests.map((contact: PublicUser) => (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                sx={{ my: 1 }}
              >
                <Box display="flex" alignItems="center">
                  <Avatar
                    alt={contact?.lastName}
                    src={getImageUrl(contact?.profilePicture)}
                    sx={{ height: "40px", width: "40px", marginRight: "8px" }}
                  />
                  <Typography component="div" variant="h6">
                    {contact?.firstName} {contact?.lastName}
                  </Typography>
                </Box>

                <AddCircleOutlineIcon
                  color="primary"
                  onClick={() => {
                    inviteGuest(contact);
                    setOpenMembresList(false);
                  }}
                />
              </Box>
            ))
          ) : (
            <Typography sx={{ my: 1 }}>Aucun membre disponible</Typography>
          )}
        </Box>
      </Modal>

      <Snackbar
        open={snack ? true : false}
        autoHideDuration={5000}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        onClose={() => setSnack(undefined)}
        message={snack} />
      {
        popoverUser && selectedContact &&
        <Popover
          open={popoverUser ? true : false}
          onClose={() => {
            setPopoverUser(undefined);
            setAnchorPop(null);
          }}
          anchorEl={anchorPop}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <UserMinimal userId={popoverUser} discussionId={selectedContact.discussionId} />
        </Popover>
      }
    </Container>
  );
};

export default Messagerie;
